const CSRF_COOKIE_NAME = 'black_peak_csrf';

function readCookie(name) {
  const prefix = `${name}=`;
  return document.cookie
    .split(';')
    .map((part) => part.trim())
    .find((part) => part.startsWith(prefix))
    ?.slice(prefix.length) || '';
}

export function apiFetch(input, options = {}) {
  const method = (options.method || 'GET').toUpperCase();
  const headers = new Headers(options.headers || {});
  if (!['GET', 'HEAD', 'OPTIONS', 'TRACE'].includes(method)) {
    const csrfToken = readCookie(CSRF_COOKIE_NAME);
    if (csrfToken) headers.set('X-CSRF-Token', csrfToken);
  }
  headers.delete('Authorization');
  return fetch(input, {
    ...options,
    credentials: 'include',
    headers,
  });
}

